import React, { useCallback, useEffect, useRef } from 'react'
import Select, { useStateManager } from 'react-select'
import { useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BaseUrl } from '../Url';
import axios from 'axios';
import "../Components/Endoment2.css"
import 'react-datepicker/dist/react-datepicker.css';
import { MdOutlineEditNote } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { MdDeleteOutline } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import ClipLoader from "react-spinners/ClipLoader";
import DatePicker from 'react-datepicker';
import NavScrollExample from './Navbar/Navbar2';
import { Modal, Button, Form } from 'react-bootstrap';
import { clear } from '@testing-library/user-event/dist/clear';
import { HiOutlineLogout } from "react-icons/hi";
import { useLocation, useNavigate } from "react-router-dom";
import number from 'availity-reactstrap-validation/lib/AvValidator/number';
import { formatDateString } from '../lib/helpers';

function Endownment2() {
  const navigate = useNavigate();
  const params=useLocation()

  const [showModal, setShowModal] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [UserId, setUserId] = useState('')

const [EditEneble, setEditEneble] = useState(false)
const [AddUpdateToast, setAddUpdateToast] = useState(false)

 useEffect(() => {
 
   const userid = params.state.UserId
 setUserId(userid)


 }, [])
 

  const handlePlusPress = () => {
    // HandelAdd()
  };
const handleModalClose=()=>{
  setShowModal2(false);
}

  const handleLogoutConfirmed = () => {
    localStorage.removeItem('isLoggedIn');
    setIsLoggedIn(false); // Update state
    navigate('/');
    setShowModal2(false);
  };


 
  useEffect(() => {
    // for localstorage of loggin check
    const isLoggedInLocalStorage = localStorage.getItem('isLoggedIn');
    if (isLoggedInLocalStorage && isLoggedInLocalStorage === 'true') {
      setIsLoggedIn(true);
    } else {
     
      navigate('/');
    }
  }, [isLoggedIn]);


// remove if no problem

  // useEffect(() => {
  //   const handleKeyPresss = (event) => {
  //     if (event.key === '+') {
  //       handlePlusPress();
  //     }
  //   };
  //   document.addEventListener('keydown', handleKeyPresss);
  //   return () => {
  //     document.removeEventListener('keydown', handleKeyPresss);
  //   };
  // }, []);

  const [ShowPlaceholder, setShowPlaceholder] = useState(false)
  const [ShowModal2, setShowModal2] = useState(false);
  const [Id, setId] = useState('')
  const [CalendarType, setCalenderType] = useState(1)
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [Green, setGreen] = useState(false)
  const handleClose = () => setShowConfirmation(false);
  const handleShow = () => setShowConfirmation(true);
  const [Disable, setDisable] = useState(false)
  const inputRef = useRef(null);
  const [sevaListArray, setSevaListArray] = useState([]);
  const [Loader, setLoader] = useState(false)
  const [Number, setNumber] = useState('')
  const [Code, setCode] = useState('')
  const [Amount, setAmount] = useState('')
  const [BookedBy, setBookedBy] = useState('')
  const [Phone, setPhone] = useState('')
  const [Gothram, setGothram] = useState('')
  const [Address, setAddress] = useState('')
  const [PerformedFor, setPerformedFor] = useState('')
  const [Star, setStar] = useState('')
  const [BookedOn, setBookedOn] = useState('');
  const [BookingPeriod, setPeriod] = useState('')
  const [ExpiryDate, setExpiryDate] = useState('')
  const [VazhipaduId, setVazhipaduId] = useState('')
  const [Quantity, setQuantity] = useState('')
  const [Rate, setRate] = useState('')
  const [InterestAmount, setInterestAmount] = useState('')
  const [Interest, setInterest] = useState('')
  const [Importance, setImportance] = useState('')
  const [Remarks, setRemark] = useState('')
  const [Reminder, setRemind] = useState('')
  const [ReminderMethod, setReminderMethod] = useState('')
  const [Month, setMonth] = useState('')
  const [WeekIndex, setWeekIndex] = useState('')
  const [weekindex1, setweekindex1] = useState('')
  const [weekindex2, setweekindex2] = useState('')
  const [PakshaOrStar, setPaksha] = useState('')
  const [PakshaOrStar1, setPaksha1] = useState('')
  const [PakshaOrStar2, setPaksha2] = useState('')
  const [Occurrence, setOccurance] = useState('') 
  const [Occurrence1, setOccurance1] = useState('')
  const [Occurrence2, setOccurance2] = useState('')
  const [WeekDay, setweek] = useState('')
  const [Malayalam, setMalayalam] = useState(true)
  const [English, setEnglish] = useState(false)
  const [Sanskrit, setSanskrit] = useState(false)
  const [Day, setDay] = useState("")
  const [VazhipaduLable, setVazhipaduLable] = useState('')
  const [selectedmonth, setselectedmonth] = useState('')
  const [RecieptNumber, setRecieptNumber] = useState('')
  const [PaymentMethod, setPaymentMethod] = useState('')
  const totalRate = sevaListArray.reduce((total, item) => total + item.Rate, 0);
  const [Add, setAdd] = useState(true)
  const [Repeat, setRepeat] = useState('')
  const [isEditMode, setIsEditMode] = useState(false);
  const [index, setindex] = useState('')
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [UpdateData, setUpdateData] = useState('')
  const [searchInput, setSearchInput] = useState('');
  const [StarValue, setStarValue] = useState('')
  const [StarLabel, setStarLabel] = useState('')
  const [Total, setTotal] = useState('')
  const [SevaListArrayupdate, setSevaListArrayupdate] = useState([])
  const [Disabe, setDisabe] = useState(false)
  const [DummyRate, setDummyRate] = useState('')
  const [UpdateRate, setUpdateRate] = useState(false)
  const [GreenColor, setGreenColor] = useState(false)
  const [clear, setclear] = useState(false)
  const [Update, setUpdate] = useState(false)
  const [inputType, setInputType] = useState('text');
  const [numbercheck, setnumbercheck] = useState(false)
  const [DeleteModal, setDeleteModal] = useState(false);
  const [indexToDelete, setIndexToDelete] = useState(null);
  const [RedColor, setRedColor] = useState(false)
  const [AmountRed, setAmountRed] = useState(false)

  const formatDateString2 = (inputDateString) => {
       
    const parsedDate = new Date(inputDateString);

    const formattedDate = `${parsedDate.getDate()}/${parsedDate.getMonth() + 1}/${parsedDate.getFullYear()}`;

    return formattedDate;
  }

  const HandelShowEditToast = ()=>{
    console.log("edit toasted is clicked");
    if(EditEneble){
      toast.error("please click edit before editing")
      
    }
  }
//   useEffect(() => {
//  setOccurance(Ocuurence1)
//   }, [Ocuurence1])

  useEffect(() => {
    setWeekIndex(weekindex1)
  }, [weekindex1])

  useEffect(() => {
    setWeekIndex(weekindex2)
  }, [weekindex2])

  useEffect(() => {
   setOccurance(Occurrence1)

  }, [Occurrence1])
  useEffect(() => {
   setOccurance(Occurrence2)
  }, [Occurrence2])

  useEffect(() => {
    setPaksha(PakshaOrStar1)
  }, [PakshaOrStar1])

  useEffect(() => {
    setPaksha(PakshaOrStar2)
  }, [PakshaOrStar2])
  
  
  
  
  
  // useEffect(() => {
  //   if(WeekDay>0){
  //     setweekindex2(WeekIndex)
  //   }else{
  //     setweekindex1(WeekIndex)
  //   }
  // }, [WeekIndex])
  

  const handelDelete = (index) => {
    // Set the index to delete and show the delete confirmation modal
    setIndexToDelete(index);
    setDeleteModal(true);
  };


  const handleBlur = (e, value) => {
    console.log("e",e.target);
    if(e.target.name === 'booked-on-date' || e.target.name === 'expired-on-date'){
      e.target.type='text';
      e.target.value=formatDateString(value);
    }else{
      setInputType('text');
      // input7Ref.current.value = formatDateString(value)

    }
  };


  const handleFocus = () => {
    console.log("worked");
    setInputType('date');
    // setExpiryDate(''); 
  };



  const handleLogout = () => {
    // Open the modal
    setShowModal2(true);
   
  };



  useEffect(() => {
    if (UpdateData.length > 0) {
      setDisabe(false);
    } else {
      setDisabe(true);
    }
  }, [UpdateData, clear])


  const HandeleEditUpdate = (e) => {
    setRedColor(false)
    if (AddUpdateToast) {
      
    

console.log("update clicked");
    e.preventDefault()
    let Numbervalue = isNaN(parseInt(Number)) ? 0 : parseInt(Number)
    let AmountValue = isNaN(parseInt(Amount)) ? 0 : parseFloat(Amount)
    let WeekDayValue = isNaN(parseInt(WeekDay)) ? -1 : parseInt(WeekDay)
    let StarValue = isNaN(parseInt(Star)) ? 0 : parseInt(Star)
    let BookingPeriodValue = isNaN(parseInt(BookingPeriod)) ? 0 : parseInt(BookingPeriod)
    let RateValue = isNaN(parseInt(Rate)) ? 0 : parseFloat(Rate)
    let QuantityValue = isNaN(parseInt(Quantity)) ? 0 : parseFloat(Quantity)
    let ReminderValue = isNaN(parseInt(Reminder)) ? 0 : parseInt(Reminder)
    let CalendarTypeValue = isNaN(parseInt(CalendarType)) ? 0 : parseInt(CalendarType)
    let MonthValue = isNaN(parseInt(Month)) ? 0 : parseInt(Month)
    let WeekIndexValue = isNaN(parseInt(WeekIndex)) ? -1 : parseInt(WeekIndex)
    let PakshaOrStarValue = isNaN(parseInt(PakshaOrStar)) ? 0 : parseInt(PakshaOrStar)
    let OccurrenceValue = isNaN(parseInt(Occurrence)) ? 0 : parseInt(Occurrence)
    let DayValue = isNaN(parseInt(Day)) ? 0 : parseInt(Day)
    let PhoneValue = isNaN(parseInt(Phone)) ? 0 : parseInt(Phone)
    let InterestValue = isNaN(parseInt(Interest)) ? 0 : parseFloat(Interest)

    const formattedDate = new Date(BookedOn).toISOString();



    // if (InterestValue < totalRate) {
    //   setAdd(false)
    //   toast.error('Your Interest amount is not sufficient for the vazhipadu', {
    //     position: toast.POSITION.TOP_CENTER,

    //   });


    //   return;
    // }
    // setSevaListArrayupdate(() => {
    //   const newArray = sevaListArray.map((row) => ({ ...row, Id: Id }));
    //   console.log("id set");
    //   console.log("newArray",newArray);
    //   return newArray;
     
    // });


    if (SevaListArrayupdate) {
      console.log("SevaListArrayupdate.length > 0");
      const newArray = sevaListArray.map((row) => ({ ...row, Id: Id }));
      if (newArray.length>0) {
      axios.post(BaseUrl + "api/Master/UpdateSaswathSeva", newArray).then(function (response) {
        if (response.status === 200) {
          toast.success('Data Updated Succussfully!', {
            position: toast.POSITION.TOP_CENTER,

          });
        } else {
          
          toast.error('Server error. Please try again later.');
        }
        setUpdate(false)
        setCode('');
        setAmount('');
        setBookedBy('');
        setPhone('');
        setGothram('');
        setAddress('');
        setPerformedFor('');
        setStar('');
        setBookedOn('');
        setPeriod('');
        setExpiryDate('');

        // setShowPlaceholder(true);

        setVazhipaduId('');
        setQuantity('');
        setRate('');
        setInterestAmount('');
        setInterest('');
        setImportance('');
        setRemark('');
        setRemind('');
        setReminderMethod('');
        setMonth('');
        setWeekIndex('');
        setweekindex1('')
        setweekindex2('')
        setPaksha('');
        setPaksha1('')
        setPaksha2('')
        setOccurance('');
        setOccurance1('')
        setOccurance2('')
        setweek('');
        setDay('');
        setPaymentMethod('');
        setNumber("")
        setSevaListArray([])
        setRecieptNumber('')
        setSearchInput('')

      }).catch(function (error) {
      })
    } else {

      console.log("else");
    }
  }
  }
  else{
    toast.error("please click add")
  }
}



  const HandelClear = () => {
    setAmountRed(false)

    setRedColor(false)
    setEditEneble(false)
    setUpdate(false)
    setRecieptNumber('')
    setCode('');
    setAmount('');
    setSearchInput('')
    setBookedBy('');
    setPhone('');
    setGothram('');
    setAddress('');
    setPerformedFor('');
    setStar('');
    setBookedOn('');
    setPeriod('');
    setExpiryDate('');
    setVazhipaduId('');
    setQuantity('');
    setRate('');
    setInterestAmount('');
    setInterest('');
    setImportance('');
    setRemark('');
    setRemind('');
    setReminderMethod('');
    setMonth('');
    setWeekIndex('');
    setweekindex1('')
    setweekindex2('')
    setPaksha('');
    setPaksha1('')
        setPaksha2('')
    setOccurance('');
    setOccurance1('')
        setOccurance2('')
    setweek('');
    setDay('');
    setPaymentMethod('');
    setSevaListArray([])
    setUpdateData('')
    setclear(true)

  }

  useEffect(() => {
  
    // for update data extention
    let selectedMonthOption;

    switch (selectedmonth) {
      case 'malayalam':
        selectedMonthOption = MalayalamMonths.find((option) => option.value === Month);
        break;
      case 'english':
        selectedMonthOption = EnglishMonths.find((option) => option.value === Month);
        break;
      case 'sanskrit':
        selectedMonthOption = SanskritMonths.find((option) => option.value === Month);
        break;
      default:
        selectedMonthOption = null;
        break;
    }

    setMonth(selectedMonthOption ? selectedMonthOption.value : '');



    setCalenderType(selectedCalenderType => {
      const mappedOption = mapCalenderTypeToOption(selectedCalenderType);
      return mappedOption.value;
    });


  }, [UpdateData]);
 

  useEffect(() => {
 

    if (UpdateData && UpdateData.length > 0) {
     
      // handleFocus()

      const {
        RecieptNo,
        BookedBy,
        Phone,
        Number,
        Amount,
        Interest,
        BookingPeriod,
        BookedOn,
        ExpiryDate,
        Code,
        Address,
        ReminderMethod,
        Reminder,
        mode,
       
        CalenderType,
       
        Id,


      } = UpdateData[0];
    

      setRecieptNumber(RecieptNo || '');
      setBookedBy(BookedBy || '');
      setPhone(Phone || '');
      setNumber(Number || '');
      setId(Id || '')
      setAmount(Amount || '');
      setInterest(Interest || '');
      setPeriod(BookingPeriod || '');
      setCode(Code || '');
      setAddress(Address || '');
      // const formatDateString = (inputDateString) => {
       
      //   const parsedDate = new Date(inputDateString);

      //   const formattedDate = `${parsedDate.getDate()}/${parsedDate.getMonth() + 1}/${parsedDate.getFullYear()}`;

      //   return formattedDate;
      // };

      setBookedOn(formatDateString(BookedOn || ''));
      setExpiryDate(formatDateString(ExpiryDate || ''));

      const selectedOption = OptionMethod.find((option) => option.value.toLowerCase() === (ReminderMethod ? ReminderMethod.toLowerCase() : ''));
      setReminderMethod(selectedOption ? selectedOption : '');

      setRemind(Reminder || '');

      setCalenderType(CalenderType || '');

      let selectedMonthOption;

      switch (CalenderType) {

        case 2:
          selectedMonthOption = MalayalamMonths.find((option) => option.value === String(Month));
          break;
        case 1:
          selectedMonthOption = EnglishMonths.find((option) => option.value === String(Month));
          break;
        case 3:
          selectedMonthOption = SanskritMonths.find((option) => option.value === String(Month));
          break;
        default:
          selectedMonthOption = null;
          break;
      }
      setCalenderType(selectedCalenderType => {
        const mappedOption = mapCalenderTypeToOption(selectedCalenderType);
        return mappedOption.value;

      });

    }
  }, [UpdateData]);

  useEffect(() => {
    if(Ratestae){
      
      return
    }else{
   setMonth('')
   setDay('')
   setWeekIndex('')
   setweekindex1('')
   setweekindex2('')
   setPaksha('')
   setPaksha1('')
        setPaksha2('')
   setOccurance('')
   setOccurance1('')
        setOccurance2('')
   setweek('')
    }
  }, [Malayalam,English,Sanskrit])
  


  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };
  const handlePopupSubmit = async (e) => {
    
    setEditEneble(false)  
    e.preventDefault();
    setUpdateRate(true);
    setUpdate(true)
    setUpdateData([]);

    try {
      let numValue = isNaN(parseInt(searchInput)) ? 0 : parseFloat(searchInput);
      const response = await axios.get(
        BaseUrl + `api/Master/GetSSevaByNum?Number=${numValue}`

      );

      if (response.status === 200) {
        const data = response.data;
        setUpdateData(data);
       console.log("response.data",response.data);
        setSevaListArray(data);
        console.log("response.data",response.data);
      } else if (response.status === 404) {
        
        // Display toast for 404 (Not Found) status

      } else {
        console.error('Error:', response.statusText);
      }
    } catch (error) {
      setEditEneble(false)
      toast.error('Please enter a valid number', {
        position: toast.POSITION.TOP_CENTER,
      });
      console.error('Error:', error.message);
    }

    handleClosePopup();

  };
  useEffect(() => {
    setUpdateRate(false);
  }, [sevaListArray])

  useEffect(() => {
    setPerformedFor("")
    setGothram("")
    setVazhipaduId("")
    setQuantity("")
    setRate("")
    setImportance("")
    setRemark("")
    setStar("")
    setMonth("")
    setDay("")
    setVazhipaduLable("")
    setweek('')
    setWeekIndex('')
    setweekindex1('')
    setweekindex2('')
    setPaksha('')
    setPaksha1('')
        setPaksha2('')
    setOccurance('')
    setOccurance1('')
        setOccurance2('')
    setPaymentMethod('')
  }, [searchInput])
  

  const setCustomPlaceholder = () => {
    // no use i guess 
    const dateInput = input7Ref.current;
    dateInput.setAttribute('placeholder', 'Date');
    dateInput.removeAttribute('onfocus');
  };

  const originalDate = new Date('Fri Dec 08 2023 11:35:00 GMT+0530 (India Standard Time)');
  const formattedDateTime = originalDate.toISOString().slice(0, -5);

  // inpurefs declarations 

  const input1Ref = React.createRef();
  const input2Ref = React.createRef();
  const input3Ref = React.createRef();
  const input4Ref = React.createRef();
  const input5Ref = React.createRef();
  const input6Ref = React.createRef();
  const input7Ref = React.createRef();
  const input8Ref = React.createRef();
  const input9Ref = React.createRef();
  const input10Ref = React.createRef();
  const input11Ref = React.createRef();
  const input12Ref = React.createRef();
  const input13Ref = React.createRef();
  const input14Ref = React.createRef();
  const input15Ref = React.createRef();
  const input16Ref = React.createRef();
  const input17Ref = React.createRef();
  const input18Ref = React.createRef();
  const input19Ref = React.createRef();
  const input20Ref = React.createRef();
  const input21Ref = React.createRef();
  const input25Ref = React.createRef();
  const input26Ref = React.createRef();
  const input27Ref = React.createRef();
  const input28Ref = React.createRef();
  const input29Ref = React.createRef();
  const input30Ref = React.createRef();
  const input32Ref = React.createRef();
  const input35Ref = React.createRef();
  const input36Ref = React.createRef();
  const input37Ref = React.createRef();
  const input38Ref = React.createRef();
  const input39Ref = React.createRef();
  const input40Ref = React.createRef();
  const input42Ref = React.createRef();
  const input43Ref = React.createRef();
  const input44Ref = React.createRef();
  const input45Ref = React.createRef();
  const input46Ref = React.createRef();
  const input47Ref = React.createRef();
  const input48Ref = React.createRef();
  const input49Ref = React.createRef();
  const input50Ref = React.createRef();
  const input60Ref = React.createRef();
  const input61Ref = React.createRef();
  const input63Ref = React.createRef();
  const input68Ref = React.createRef();
  const input22Ref = React.createRef();
  const input23Ref = React.createRef();
  const input24Ref = React.createRef();
  const input33Ref = React.createRef();
  const input34Ref = React.createRef();
  const input41Ref = React.createRef();
  const input51Ref = React.createRef();
  const input31Ref = React.createRef();



  const handleDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    setBookedOn(selectedDate);
  };

  const handleDateChange2 = (e) => {
    const selectedDate = new Date(e.target.value);
    setExpiryDate(selectedDate);
  };

  const handleMenuClose = () => {
    input21Ref.current.focus();
  }

  const handleKeyDown = (e, nextFieldRef, nextFieldRef2) => {
    if (e.key === 'Enter') {

      e.preventDefault();
      nextFieldRef.current.focus();
    }
    if (e.key === 'ArrowLeft') {

      nextFieldRef2.current.focus();
    }
  };

 

  const handleKeyDownAdd = (e, nextFieldRef, nextFieldRef2, nextFieldRef3) => {
    if (e.key === 'Enter') {

      e.preventDefault();
      nextFieldRef.current.focus();
    }
    if (e.key === 'ArrowLeft') {

      nextFieldRef2.current.focus();
    }
    if (e.key === 'Add' || e.code === 'NumpadAdd' || e.code === 'Equal' || e.key === '+') {

      nextFieldRef3.current.focus();

    }
  };

  const [chosenItem, setchosenItem] = useState([])
  const [editedPerformedFor, setEditedPerformedFor] = useState('');
const [Ratestae, setRatestae] = useState(false)
  const handleEditList = (index) => {
    setEditEneble(false)
    setIsEditMode(true);
    // edit on list 
    setRatestae(true)
   
    setindex(index);
    setchosenItem(sevaListArray[index]);
    console.log("sevaListArray[index]",sevaListArray[index]);
    setRate(sevaListArray[index].Rate)
    
    
const selectedmode = mode?.find((item) => item.BMode === sevaListArray[index].Mode);


if (selectedmode) {
 
  const formattedmode = {
    value: selectedmode.BMode,
    label: selectedmode.BName,
  };

  Handelmode(formattedmode);
 
} else {
 
}


    const selectedStarOption = OptionStar.find((option) => option.value === String(Star));
    setStar(selectedStarOption);
    const selectedOptionVazhipadu = SevaData?.resultdata?.find((item) => item.Id === sevaListArray[index].VazhipaduId);
   
    const selectedweekoption = optionWeek.find((option) => option.value === (WeekDay))
    setweek(selectedweekoption)
    if (selectedOptionVazhipadu) {
      const formattedOption = {
        Id: selectedOptionVazhipadu.Id,
        label: selectedOptionVazhipadu.VName,
        value: selectedOptionVazhipadu.Code,
        Rate:selectedOptionVazhipadu.Rate
      };


      handlevazhipadu(formattedOption);
    }

    // if(sevaListArray[index].WeekIndex>0){
    //   setweekindex2(WeekIndex)
    // }else{
    //   setweekindex2(weekindex1)
    // }

    setVazhipaduLable(chosenItem.VazhipaduLable);

  };

   

  useEffect(() => {
    setUpdateRate(false)
  }, [Number])




  useEffect(() => {
  
    if (chosenItem) {
      console.log("chosenItem",chosenItem);
      setPerformedFor(chosenItem.PerformedFor);
      setGothram(chosenItem.Gothram);
      setQuantity(chosenItem.Quantity);
      setImportance(chosenItem.Importance);
      setRemark(chosenItem.Remarks);
      const selectedStarOption = OptionStar.find((option) => option.value === String(chosenItem.Star));
      setStar(selectedStarOption);
      const selectedOptionVazhipadu = SevaData?.resultdata?.find((item) => item.Id === chosenItem.VazhipaduId);
    //   setOccurance(chosenItem.Occurance)
    //  if(chosenItem.Day>0){
    //   setOccurance1(chosenItem.Occurance)
    //  }else{
    //   setOccurance2(chosenItem.Occurance)
    //  }
    if (chosenItem.Occurrence > 0) {
      setOccurance(chosenItem.Occurrence);
    
      if (chosenItem.Day > 0) {
        setOccurance1(chosenItem.Occurrence);
      } else {
        setOccurance2(chosenItem.Occurrence);
      }
    } else {
      
    }
      
       setmode(chosenItem.mode)
      if (selectedOptionVazhipadu) {
        const formattedOption = {
          Id: selectedOptionVazhipadu.Id,
          label: selectedOptionVazhipadu.VName,
          value: selectedOptionVazhipadu.Code,
        };


        handlevazhipadu(formattedOption);
      }
      setVazhipaduLable(chosenItem.VazhipaduLable);
      if (chosenItem.CalendarType !== undefined) {
        setCalenderType(chosenItem.CalendarType);
      }
// setPaymentMethod(chosenItem.mode)
      setMonth(chosenItem.Month);
      // Handelmode(chosenItem.Mode)
      let selectedMonthOption;

      switch (chosenItem.CalendarType) {

        case 2:
          selectedMonthOption = MalayalamMonths.find((option) => option.value === String(chosenItem.Month));
          break;
        case 1:
          selectedMonthOption = EnglishMonths.find((option) => option.value === String(chosenItem.Month));
          break;
        case 3:
          selectedMonthOption = SanskritMonths.find((option) => option.value === String(chosenItem.Month));
         
          break;
        default:
          selectedMonthOption = null;
         
          break;
      }

      setMonth(selectedMonthOption);
      setDay(chosenItem.Day);
      // setOccurance(chosenItem.Occurrence);
      // setPaksha(chosenItem.PakshaOrStar);

      // setweek(chosenItem.WeekDay);
      setWeekIndex(chosenItem.WeekIndex);

      let DayValue = isNaN(parseInt(Day)) ? 0 : parseInt(Day)

      const selectedDayOptions = DaysOption.find((option) => option.value === String(chosenItem.Day))

      setDay(selectedDayOptions);
      const selectedweekoption = optionWeek.find((option) => option.value === String(chosenItem.WeekDay))
      setweek(selectedweekoption)

      // const selectedweekindex = EveryDay.find((option) => option.value === String(chosenItem.WeekIndex))
      // setWeekIndex(selectedweekindex)

     

      let Everyday;

      if (chosenItem.WeekDay > 0) {
        Everyday = EveryDay2;
       
      } else {
        Everyday = EveryDay1; 
       
      }
      
      const selectedWeekIndex = Everyday.find((option) => option.value === String(chosenItem.WeekIndex));
      if (chosenItem.WeekDay > 0) {
        setweekindex2(selectedWeekIndex)
       
      } else {
       setweekindex1(selectedWeekIndex)
       
      }

      
      
// Now use the 'everyday' variable as needed in your code.

      // setweekindex1(selectedweekindex)
     
      let selectedArray;

if (chosenItem.CalendarType === 3 && chosenItem.Day !== 0) {
  
  selectedArray = OptionPaksha;
} else if (chosenItem.CalendarType === 3 && chosenItem.Day === 0) {
 
  selectedArray = OptionStar;
} else {
 
  selectedArray = OptionStar; 
}

const Selectedpaksha = selectedArray.find((option) => option.value === String(chosenItem.PakshaOrStar));
// setPaksha(Selectedpaksha);
     if(chosenItem.CalendarType === 3 && chosenItem.Day !== 0){
      setPaksha1(Selectedpaksha)
     }else if(chosenItem.CalendarType === 3 && chosenItem.Day == 0){
      setPaksha2(Selectedpaksha)
     }else{
      setPaksha(Selectedpaksha);

     }

   
      
    }

  }, [chosenItem ]);

useEffect(() => {
 
}, [WeekDay,Day])

  

  const confirmDelete = async () => {
    if (indexToDelete !== null) {
      const selectedItem = sevaListArray[indexToDelete];
      const deletedItemId = selectedItem?.VazhipaduId;  // Adjust this line
  
      
  
      if (deletedItemId) {
        try {
          // Make the DELETE request to the API endpoint
          await axios.post(BaseUrl + `api/Master/DeleteSaswathseva`, {
            SaswathSevaId: deletedItemId,
          });
  
          // Assuming the API call was successful, update the state with the new array
          setSevaListArray(prevState => prevState.filter((item, i) => i !== indexToDelete));
        } catch (error) {
          console.error('There was a problem with the Axios DELETE request:', error);
          // Handle error as needed
        } finally {
          // Close the modal and reset the indexToDelete
          setDeleteModal(false);
          setIndexToDelete(null);
        }
      }
    }
  };
  
  
useEffect(() => {
  console.log("remindermethod",ReminderMethod);
}, [ReminderMethod,Reminder])


  // useEffect(() => {
  //   axios.get(BaseUrl + "api/Master/GetNextnumberForSaswathseva").then(function (response) {

  //     setNumber(response.data)

  //   })
  //     .catch(function (err) {
  //     })
  // }, [CalendarType, BookedBy,numbercheck])


  const HandelAdd = () => {
    setAddUpdateToast(true)

setnumbercheck(true)

    if (
      (!Amount || Amount === '') ||
      (!BookedBy || BookedBy === '') ||
      (!Address || Address === '') ||
      (!Interest || Interest === '') ||
      (!Quantity || Quantity === '') ||
      (!BookingPeriod || BookingPeriod ==='')||
      (!Month || Month === '') ||
      (!VazhipaduId || VazhipaduId === '') ||
     ! (
        (typeof  Day!== 'undefined' && Day !== null) ||
        // (typeof WeekIndex !== 'undefined' && WeekIndex !== null) ||
        (typeof Occurrence !== 'undefined' && Occurrence !== null) ||
        (typeof PakshaOrStar !== 'undefined' && PakshaOrStar !== null) ||
        (typeof WeekDay !== 'undefined' && WeekDay !== null)
      )
    ) {
      toast.error('Please fill in all required fields or provide a valid combination for day, week index, occurrence, star, or weekday.', {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

  
    setAdd(false)
    setDisable(true)




    let AmountValue = isNaN(parseInt(Amount)) ? 0 : parseFloat(Amount)
    let BookingPeriodValue = isNaN(parseInt(BookingPeriod)) ? 0 : parseInt(BookingPeriod)
    let RateValue = isNaN(parseInt(Rate)) ? 0 : parseFloat(Rate)
    let QuantityValue = isNaN(parseInt(Quantity)) ? 0 : parseFloat(Quantity)
    let ReminderValue = isNaN(parseInt(Reminder)) ? 0 : parseInt(Reminder)
    let CalendarTypeValue = isNaN(parseInt(CalendarType)) ? 0 : parseInt(CalendarType)
   
    let PakshaOrStarValue = PakshaOrStar ? parseInt(PakshaOrStar.value) : 0
    let OccurrenceValue = isNaN(parseInt(Occurrence)) ? 0 : parseInt(Occurrence)
    let DayValue = Day ? parseInt(Day.value) : 0
    let MonthValue = Month ? parseInt(Month.value) : 0
    let PhoneValue = isNaN(parseInt(Phone)) ? 0 : parseInt(Phone)
    let InterestValue = isNaN(parseInt(Interest)) ? 0 : parseFloat(Interest)

    let Remarksvalue = Remarks ? Remarks : ''
    let Importancevalue = Importance ? Importance : ''
    const formattedDate = new Date(BookedOn);
    const formattedDate2 = new Date(ExpiryDate);
    let GothramValue = Gothram ? Gothram : ''
    // let remindermethodvalue = ReminderMethod?ReminderMethod.value :null

    const SevaListTable = {
      
      Gothram:GothramValue,
      VazhipaduId: VazhipaduId.Id,
      Star: Star ? parseInt(Star.value, 10) : 0,
      Mode:PaymentMethod? parseInt(PaymentMethod.value,10):0,
      Quantity: QuantityValue,
      Rate: RateValue,
      Importance: Importancevalue,
      Remarks: Remarksvalue,
      CalendarType: CalendarTypeValue,
      Month: MonthValue,
      DummyRate,
      // WeekDay: isNaN(parseInt(WeekDay.value, 10)) ? 0 : parseInt(WeekDay.value, 10),
      // WeekDay:WeekDay?parseInt(WeekDay.value,10):0,
      WeekDay: WeekDay && WeekDay.value ? parseInt(WeekDay.value, 10) : -1,


      WeekIndex: WeekIndex ? parseInt(WeekIndex.value, 10) : -1,
      Occurrence: OccurrenceValue,
      Day: DayValue,
      PakshaOrStar: PakshaOrStarValue,
      PerformedFor,
      VazhipaduLable: VazhipaduLable.label

    }
   

    const Data = {
      // Number: Number[0]?.number,
      Code,
      Amount: AmountValue,
      BookedBy,
      Phone,
      Address,
      bookedOn: formattedDate,
      BookingPeriod: BookingPeriodValue,
      Interest: InterestValue,
      Reminder: ReminderValue,
      // ReminderMethod: ReminderMethod.value,
      ReminderMethod: ReminderMethod.value !== null && ReminderMethod.value !== '' ? ReminderMethod.value : null,
    

      ExpiryDate: formattedDate2,
      RecieptNumber,
      UserId

    }

    if (isEditMode) {
            const SevaListTable = {
              

        Gothram:GothramValue,
        VazhipaduId: VazhipaduId.Id,
        Star: Star ? parseInt(Star.value, 10) : 0,
        Quantity: QuantityValue,
        // Rate:VazhipaduId.Rate * QuantityValue,
        Rate:RateValue,
        Mode:PaymentMethod? parseInt(PaymentMethod.value,10):0,
        Importance,
        Remarks,
        CalendarType: CalendarTypeValue,
        // Month: parseInt(Month.value, 10),
        Month:MonthValue,
        DummyRate,

        WeekDay: WeekDay ? parseInt(WeekDay.value, 10) : -1,
        WeekIndex: WeekIndex ? parseInt(WeekIndex.value, 10) : -1,
        Occurrence: OccurrenceValue,
        Day: DayValue,
        PakshaOrStar: PakshaOrStarValue,
        PerformedFor,
        // VazhipaduLable:VazhipaduLable.label,



      }

 
      const Data = {
        // Number: Number[0]?.number,
        Code,
        Amount: AmountValue,
        BookedBy,
        Phone,
        Address,
        bookedOn: formattedDate,
        BookingPeriod: BookingPeriodValue,
        Interest: InterestValue,
        // ReminderMethod: ReminderMethod.value,
        ReminderMethod: ReminderMethod.value !== null && ReminderMethod.value !== "" ? ReminderMethod.value : null,
        Reminder: ReminderValue,
        ExpiryDate: formattedDate2,
        RecieptNumber: RecieptNumber,
        UserId

      }

      setSevaListArray((prevArray) => {
        const newArray = [...prevArray];
        newArray[index] = SevaListTable;
        return newArray;
      });
      setSevaListArray((prevArray) => {
        const newArray = prevArray.map((row) => ({ ...row, ...Data }));

        return newArray;


      });

      setIsEditMode(false);
    } else {

      setSevaListArray((prevArray) => {
        const newArray = [...prevArray, SevaListTable];

        return newArray;
      });

      setSevaListArray((prevArray) => {
        const newArray = prevArray.map((row) => ({ ...row, ...Data }));

        return newArray;

      });
    }

    setPerformedFor("")
    setGothram("")
    setVazhipaduId("")
    setQuantity("")
    setRate("")
    setImportance("")
    setRemark("")
    setStar("")
    setMonth("")
    setDay("")
    setVazhipaduLable("")
    setweek('')
    setWeekIndex('')
    setweekindex1('')
    setweekindex2('')
    setPaksha('')
    setPaksha1('')
        setPaksha2('')
    setOccurance('')
    setOccurance1('')
        setOccurance2('')
    setPaymentMethod('')
   setnumbercheck(false)

  }
  // useEffect(() => {
   
   
  //   if (!UpdateRate) {
  //     let InterestValue = isNaN(parseInt(Interest)) ? 0 : parseFloat(Interest);

  //     if (InterestValue < totalRate) {
  //       toast.error("Your amount is not sufficient for the vazhipadu", {
  //         position: toast.POSITION.TOP_CENTER,
  //       });

       
  //       setSevaListArray((prevArray) => {
  //         const newArray = [...prevArray];
  //         newArray.pop(); // Remove the last element
  //         return newArray;
  //       });
  //       return;
  //     }
  //   }
  // }, [sevaListArray, UpdateRate]);

  useEffect(() => {
   
   
    if (!UpdateRate) {
      let InterestValue = isNaN(parseInt(Interest)) ? 0 : parseFloat(Interest);

      if (InterestValue < totalRate) {
        setRedColor(true)
      }
    }
  }, [sevaListArray, UpdateRate]);



  const handleKeyDown2 = (e, nextFieldRef, nextFieldRef2) => {
    if (e.key === 'Enter') {

      nextFieldRef.current.focus();
    }

    if (e.key === 'ArrowLeft') {

      nextFieldRef2.current.focus();
    }
  };

  const handleKeyDown4 = (e, nextFieldRef, nextFieldRef2) => {
    if (e.key === 'Enter') {
      if (e.shiftKey) {
        // Do nothing if the Shift key is pressed along with Enter
        return;
      }

      e.preventDefault(); 
      nextFieldRef.current.focus();
    } else if (e.key === 'ArrowLeft') {
      nextFieldRef2.current.focus();
    }
  };


  const handlecalender = (e, nextFieldRef, nextFieldRef2, nextFieldRef3, nextFieldRef4) => {
    // setting calender type 
    if (CalendarType === 2) {
      if (e.key === 'Enter') {

        // e.preventDefault();
        nextFieldRef.current.focus();
      }
      if (e.key === 'ArrowLeft') {

        // e.preventDefault();
        nextFieldRef4.current.focus();
      }

    }
    if (CalendarType === 1) {
      if (e.key === 'Enter') {
        // e.preventDefault();
        nextFieldRef2.current.focus();
      }
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        nextFieldRef4.current.focus();
      }
    }
    if (CalendarType === 3) {
      if (e.key === 'Enter') {
        // e.preventDefault();
        nextFieldRef3.current.focus();
      }
      if (e.key === 'ArrowLeft') {
        // e.preventDefault();

        nextFieldRef4.current.focus();
      }

    }
    if (CalendarType === 4) {
      if (e.key === 'ArrowLeft') {

        nextFieldRef4.current.focus();
      }
    }
  }
  const handlemalayalam = (e, nextFieldRef, nextFieldRef2) => {
    if (e.key === 'Enter') {

      nextFieldRef.current.focus();
    }
  }



  useEffect(() => {
    // seting calender state truw 
    if (CalendarType === 2) {
      setMalayalam(true);
      setEnglish(false);
      setSanskrit(false);
    }
    else if (CalendarType === 1) {
      setMalayalam(false)
      setSanskrit(false)
      setEnglish(true);

    } else if (CalendarType === 3) {
      setMalayalam(false)
      setEnglish(false)
      setSanskrit(true);
    }
    else {
      setMalayalam(false)
      setEnglish(false)
      setSanskrit(false)

    }


  },
    [CalendarType])

  const cardStyle = {
    background: (CalendarType === 2 && Malayalam) ? 'linear-gradient(to right, #ff839d, #fec180)' :
      (CalendarType === 1 && English) ? 'linear-gradient(to right, #af8f9d, #fea88f)' :
        (CalendarType === 3 && Sanskrit) ? 'linear-gradient(to right, #f3dcfb, #ff839d)' : 'linear-gradient(to right, #f3dcfb,   #abdcff)',

  };

  const HandelSave = (e) => {

    setRedColor(false)
    if(sevaListArray.length === 0) {
  
      toast.error('Please Add Data before save', {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    } else {
     
    }
   
    setLoader(true)

    e.preventDefault()

    let Numbervalue = isNaN(parseInt(Number)) ? 0 : parseInt(Number)
    let AmountValue = isNaN(parseInt(Amount)) ? 0 : parseFloat(Amount)
    let WeekDayValue = isNaN(parseInt(WeekDay)) ? -1 : parseInt(WeekDay)
    let StarValue = isNaN(parseInt(Star)) ? 0 : parseInt(Star)
    let BookingPeriodValue = isNaN(parseInt(BookingPeriod)) ? 0 : parseInt(BookingPeriod)
    let RateValue = isNaN(parseInt(Rate)) ? 0 : parseFloat(Rate)
    let QuantityValue = isNaN(parseInt(Quantity)) ? 0 : parseFloat(Quantity)
    let ReminderValue = isNaN(parseInt(Reminder)) ? 0 : parseInt(Reminder)
    let CalendarTypeValue = isNaN(parseInt(CalendarType)) ? 0 : parseInt(CalendarType)
    let MonthValue = isNaN(parseInt(Month)) ? 0 : parseInt(Month)
    let WeekIndexValue = isNaN(parseInt(WeekIndex)) ? -1 : parseInt(WeekIndex)
    let PakshaOrStarValue = isNaN(parseInt(PakshaOrStar)) ? 0 : parseInt(PakshaOrStar)
    let OccurrenceValue = isNaN(parseInt(Occurrence)) ? 0 : parseInt(Occurrence)
    let DayValue = isNaN(parseInt(Day)) ? 0 : parseInt(Day)
    let PhoneValue = isNaN(parseInt(Phone)) ? 0 : parseInt(Phone)
    let InterestValue = isNaN(parseInt(Interest)) ? 0 : parseFloat(Interest)


    const formattedDate = new Date(BookedOn).toISOString();


    if (sevaListArray.length > 0) {

      axios.post(BaseUrl + "api/Master/SetData", sevaListArray).then(function (response) {
        if (response.status === 200) {
          setLoader(false)
          setGreen(true)

          setTimeout(() => {
            setGreen(false)

          }, 3000);

          toast.success('Data successfully saved!', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000

          });
        } else {
          toast.error('Server error. Please try again later.');
        }


        setCode('');
        setAmount('');
        setBookedBy('');
        setPhone('');
        setGothram('');
        setAddress('');
        setPerformedFor('');
        setStar('');
        setBookedOn('');
       
        setPeriod('');
        setExpiryDate('');
        setVazhipaduId('');
        setQuantity('');
        setRate('');
        setInterestAmount('');
        setInterest('');
        setImportance('');
        setRemark('');
        setRemind('');
        setReminderMethod('');
        setMonth('');
        setWeekIndex('');
        setweekindex1('')
        setweekindex2('')
        setPaksha('');
        setPaksha1('')
        setPaksha2('')
        setOccurance('');
        setOccurance1('')
        setOccurance2('')
        setweek('');
        setDay('');
        setPaymentMethod('');
        setAmountRed(false)

        setNumber("")
        setRecieptNumber('')
        setSevaListArray([])



      }).catch(function (error) {
        console.log(error);
      })
    } else {
      console.log(alert("please click add before saving"));
      setLoader(false)
    }
  }
  useEffect(() => {
    setExpiryDate('')
  }, [Loader])



  const [SevaData, setSevaData] = useState([])

  useEffect(() => {
    //  to get list of vazhipadu 
    axios.get(BaseUrl + "api/Master/vazhipaduList").then(function (response) {
     
      setSevaData(response.data)

    }).catch(function (err) {
      console.log(err);
    })


  }, [Number])

const [mode, setmode] = useState([])
  useEffect(() => {
    //  to get list of vazhipadu 
    axios.get(BaseUrl + "api/Master/GetMode").then(function (response) {
      setmode(response.data)

    }).catch(function (err) {
      console.log(err);
    })


  }, [Number,isEditMode,EditEneble])


  

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      fontSize: '12px',
      minHeight: '31px !important',  // Set min-height and make it important
      height: '2px',  // Adjust the height as needed
    }),
    option: (provided, state) => ({
      ...provided,
      // Additional styles for the options if needed
    }),
  };
  
  

  const mapCalenderTypeToOption = (calenderType) => {
    switch (calenderType) {
      case 1:
        return { value: 1, label: 'Malayalam' };
      case 2:
        return { value: 2, label: 'English' };
      case 3:
        return { value: 3, label: 'Sanskrit' };
      default:
        return { value: 4, label: <b>Choose Calendar</b> };
    }
  };

  useEffect(() => {

    handlevazhipadu(VazhipaduId);
  }, [VazhipaduId,Quantity]);

  const handlevazhipadu = (value) => {
   
    setVazhipaduId(value);
    setVazhipaduLable(value)
    // if (!isEditMode) {
    setDummyRate(value.Rate)
   
  }
  const Handelmode =(value)=>{
setPaymentMethod(value)



  }

  
  useEffect(() => {

    const updatedRate = DummyRate * Quantity;
    if (Quantity > 0 && DummyRate) {
     
      setRate(updatedRate);
    } else {
    
      setRate(Rate);
    }
  }, [Quantity, UpdateData, chosenItem, DummyRate]);


  const handlePayment = (e) => {
    if (e.key === 'Enter') {

      input63Ref.current.focus();
    }
  };

  // section option 

  const EnglishMonths = [
    { value: '', label: 'Choose Month*' },
    { value: '1', label: 'January' },
    { value: '2', label: 'February' },
    { value: '3', label: 'March' },
    { value: '4', label: 'April' },
    { value: '5', label: 'May' },
    { value: '6', label: 'June' },
    { value: '7', label: 'July' },
    { value: '8', label: 'August' },
    { value: '9', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
    { value: '13', label: 'Every Month' }
  ];

  const EveryDay1 = [

    { value: '0', label: 'Every' },
    { value: '1', label: 'First' },
    { value: '2', label: 'Second' },
    { value: '3', label: 'Third' },
    { value: '4', label: 'Fourth' },
    { value: '5', label: 'Fifth' },

  ];

  const EveryDay = [

    { value: '0', label: 'Every' },
    { value: '1', label: 'First' },
    { value: '2', label: 'Second' },
    { value: '3', label: 'Third' },
    { value: '4', label: 'Fourth' },
    { value: '5', label: 'Fifth' },

  ];
  const EveryDay2 = [

    { value: '0', label: 'Every' },
    { value: '1', label: 'First' },
    { value: '2', label: 'Second' },
    { value: '3', label: 'Third' },
    { value: '4', label: 'Fourth' },
    { value: '5', label: 'Fifth' },

  ];

  const Options = [
    { value: 4, label: <b>Choose Calendar</b> },
    
    { value: 1, label: 'English' },
    { value: 2, label: 'Malayalam' },
    { value: 3, label: 'Sanskrit' },
  ];

  const OptionPaksha = [
    { value: '0', label: <b>Paksha</b> },
    { value: '2', label: 'ശുക്ല പക്ഷ' },
    { value: '1', label: 'കൃഷ്ണ പക്ഷ' },

  ];
  const optionWeek = [
    { value: '10', label: 'Select Week' },
    { value: '0', label: 'Day' },
    { value: '1', label: 'Sunday' },
    { value: '2', label: 'Monday' },
    { value: '3', label: 'Tuesday' },
    { value: '4', label: 'Wednesday' },
    { value: '5', label: 'Thursday' },
    { value: '6', label: 'Friday' },
    { value: '7', label: 'Saturday' },
  ]

  const SanskritMonths = [
    { value: '', label: 'Choose Month*' },
    { value: '1', label: 'Chaitra' },
    { value: '2', label: 'Vaishakha' },
    { value: '3', label: 'Jyeshtha' },
    { value: '4', label: 'Ashadha' },
    { value: '5', label: 'Shravana' },
    { value: '6', label: 'Bhadrapada' },
    { value: '7', label: 'Ashwin' },
    { value: '8', label: 'Kartika' },
    { value: '9', label: 'Margashira' },
    { value: '10', label: 'Pausha' },
    { value: '11', label: 'Magha' },
    { value: '12', label: 'Phalguna' },
    { value: '13', label: 'Every Month' }
  ];

  const PaymentMethodOption = [
    { value: '', label: 'Payment Method' },
    { value: 'Money Order', label: 'Money Order' },
    { value: 'By Cash', label: 'By Cash' },
    { value: 'Online', label: 'Online' },
    { value: 'Cheque or DD', label: 'Cheque or DD' },
    { value: 'move to hundi', label: 'move to hundi' },
    { value: 'Card', label: 'Card' },
  ];
  const OptionMethod = [
    { value: '', label: 'ReminderMethod' },
    { value: 'Mail automatic', label: 'Mail Automatic' },
    { value: 'SMS Automatic', label: 'SMS Automatic' },

  ];

  const MalayalamMonths = [
    { value: '', label: 'Choose Month*' },
    { value: '1', label: 'ചിങ്ങം' },
    { value: '2', label: 'കന്നി' },
    { value: '3', label: 'തുലാം' },
    { value: '4', label: 'വൃശ്ചികം' },
    { value: '5', label: 'ധനു' },
    { value: '6', label: 'മകരം' },
    { value: '7', label: 'കുംഭം' },
    { value: '8', label: 'മീനം' },
    { value: '9', label: 'മേടം' },
    { value: '10', label: 'ഇടവം' },
    { value: '11', label: 'മിഥുനം' },
    { value: '12', label: 'കർക്കടകം' },
    { value: '13', label: 'എല്ലാമാസം' }

  ];

  const OptionStar = [
    { value: '', label: 'നക്ഷത്രം തിരഞ്ഞെടുക്കുക' },
    { value: '1', label: 'അശ്വതി' },
    { value: '2', label: 'ഭരണി' },
    { value: '3', label: 'കാർത്തിക' },
    { value: '4', label: 'രോഹിണി' },
    { value: '5', label: 'മകയിരം' },
    { value: '6', label: 'തിരുവാതിര' },
    { value: '7', label: 'പുണർതം' },
    { value: '8', label: 'പൂയം' },
    { value: '9', label: 'ആയില്യം' },
    { value: '10', label: 'മകം' },
    { value: '11', label: 'പൂരം' },
    { value: '12', label: 'ഉത്രം' },
    { value: '13', label: 'അത്തം' },
    { value: '14', label: 'ചിത്തിര' },
    { value: '15', label: 'ചോതി' },
    { value: '16', label: 'വിശാഖം' },
    { value: '17', label: 'അനിഴം' },
    { value: '18', label: 'തൃക്കേട്ട' },
    { value: '19', label: 'മൂലം' },
    { value: '20', label: 'പൂരാടം' },
    { value: '21', label: 'ഉത്രാടം' },
    { value: '22', label: 'തിരുവോണം' },
    { value: '23', label: 'അവിട്ടം' },
    { value: '24', label: 'ചതയം' },
    { value: '25', label: 'പൂരുരുട്ടാതി' },
    { value: '26', label: 'ഉത്തൃട്ടാതി' },
    { value: '27', label: 'രേവതി' },
  ];


  const DaysOption = [
    { value: "0", label: "Day" },
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
    { value: "13", label: "13" },
    { value: "14", label: "14" },
    { value: "15", label: "15" },
    { value: "16", label: "16" },
    { value: "17", label: "17" },
    { value: "18", label: "18" },
    { value: "19", label: "19" },
    { value: "20", label: "20" },
    { value: "21", label: "21" },
    { value: "22", label: "22" },
    { value: "23", label: "23" },
    { value: "24", label: "24" },
    { value: "25", label: "25" },
    { value: "26", label: "26" },
    { value: "27", label: "27" },
    { value: "28", label: "28" },
    { value: "29", label: "29" },
    { value: "30", label: "30" },
    { value: "31", label: "31" },

  ];

  const tableContainerStyle = {
    maxHeight: CalendarType === 4 ? '123px' : '123px',
    overflowY: 'auto',
    width: '100%',
    paddingLeft: '5px',
    PaddingRight: '5px',
    backgroundColor: ""

  };

  const CalenderContainerStyle = {
    backgroundColor: CalendarType === 4 ? '' : '133px',

  };

  const tdStyle = {

    height: CalendarType === 4 ? '100px !important' : 'auto',

  };

  useEffect(() => {
    const numericInterest = parseFloat(Interest);
    const numericAmount = parseFloat(Amount);
  
    if (!isNaN(numericInterest) && !isNaN(numericAmount) && numericInterest > numericAmount) {
      console.log("Interest is greater than Amount");
      setAmountRed(true);
    } else {
      console.log("Interest is not greater than Amount");
      setAmountRed(false);
    }
  }, [Amount, Interest]);
  
  
  // const BookedOnComponent = useCallback(() => {
  //   return (<input
  //     type={inputType}

  //     name=""
  //     className='form-control'
  //     id=""
  //     onBlur={(event) => (event.target.type = 'type')}
  //     onFocus={(event) => (event.target.type = 'date')}
  //     // onFocus={handleFocus}
  //     onChange={(e) => { setExpiryDate(e.target.value) }}
  //     value={ExpiryDate}
  //     placeholder='Expiry Date*'
  //     disabled={EditEneble}

  //     onKeyDown={(e) => handleKeyDown2(e, input9Ref, input7Ref)}
  //     ref={input8Ref}
  //   />)
  // }, [])


  return (
    <div>
     
      <nav className="navbar navbar-expand-lg bg-body-tertiary pl-0" style={{ background: Green ? "#5EBE76" : "linear-gradient(to right, #f3dcfb, #679fe4)" }}>



        <span className="navbar-toggler-icon"></span>

        <div className="collapse navbar-collapse" id="navbarScroll">

          <form className="d-flex">
            <input
              className="form-control2  "
              type="text"
              onChange={(e) => { setSearchInput(e.target.value) }}
              value={searchInput}
              placeholder="Search Number"
              aria-label="Search"
              
                     
                      // onKeyDowonKeyDown={(e) => handleKeyDown2(e, input5Ref, input3Ref)}
              
              // onBlur={handleBlur}

            />
            <button style={{ backgroundColor: "#001766", color: "white" }} className="btn  ml-2" onClick={handlePopupSubmit}  >
              Search
            </button>
          </form>
         
        </div>
        <button onClick={handleLogout} style={{ backgroundColor: "transparent", color: "#001766"  }} className="btn ml-auto mr-3" >
  <HiOutlineLogout style={{ height: '30px', width: '30px' }} />

</button>


      </nav>
      
      <div className="row">

        {/* -------------------------------first------------------------------------- */}

        <div className=" container-fluid col-lg-7 card pl-4 ">
          <div className="row">
            <div className="container ">
              <div className="col-12 card " onClick={HandelShowEditToast} style={{ background: 'linear-gradient(to right, #ff9492, #7d77aa)' }}>
                {/*  */}
                <div className="row mb-1 ">

                  <div className="col-lg-8 ">
                    <div><b>Booking Details</b></div>
                  </div>
                  
                  {Update && (
                    <div className="col-lg-4 pb-1 number justify-content-end d-flex">
                      <b style={{ color: "white" }}> Number:</b> <b style={{ color: "white" }}>{Number}</b>
                    </div>
                  )}


                </div>

                <div className="row" >
  <div className="col-lg-4">
    <input
      type="text"
      name=""
      className="form-control"
      id=""
      disabled={EditEneble}
      placeholder="Reciept Number"
      value={RecieptNumber}
      onChange={(e) => {
        setRecieptNumber(e.target.value);
      }}
      onKeyDown={(e) => handleKeyDown(e, input2Ref)}
      onKeyPress={(e) => {
        // Allow only numeric input
        const isNumeric = /^[0-9]*$/.test(e.key);
        if (!isNumeric) {
          e.preventDefault();
        }
      }}
      ref={input1Ref}
    />
  </div>
  <div className="col-lg-4">
    <input
      type="text"
      name="Booked By"
      className="form-control"
      id="Booked By"
      value={BookedBy}
      onChange={(e) => {
        setBookedBy(e.target.value);
      }}
      placeholder="Booked By*"
      onKeyDown={(e) => handleKeyDown(e, input3Ref, input1Ref)}
      ref={input2Ref}
      disabled={EditEneble}
    />
  </div>
  <div className="col-lg-4">
    <input
      type="text"
      name="Phone"
      className="form-control"
      id="Phone"
      placeholder="Phone*"
      disabled={EditEneble}
      value={Phone}
      onKeyPress={(e) => {
        // Allow only numeric input
        const isNumeric = /^[0-9]*$/.test(e.key);
        if (!isNumeric) {
          e.preventDefault();
        }
      }}
      onChange={(e) => {
        setPhone(e.target.value);
      }}
      onKeyDown={(e) => handleKeyDown(e, input4Ref, input2Ref)}
      ref={input3Ref}
    />
  </div>
</div>

                <div className="row ">

                  <div className="col-lg-4">
                    <input
                      type="text"
                      id="Amount"
                      name="Amount"
                      className='form-control'
                      style={AmountRed?{backgroundColor:"pink",borderColor:"red"}:{}}
                      value={Amount}
                      onChange={(e) => { setAmount(e.target.value) }}
                      placeholder='Amount*'
                      disabled={EditEneble}

                      onKeyPress={(e) => {
                        // Allow only numeric input
                        const isNumeric = /^[0-9]*$/.test(e.key);
                        if (!isNumeric) {
                          e.preventDefault();
                        }
                      }}
                      onKeyDown={(e) => handleKeyDown(e, input5Ref, input3Ref)}
                      ref={input4Ref}
                    // disabled={Disable} 
                    />
                  </div>
                  <div className="col-lg-4">
                    <input
                      type="text"
                      name="Interest"
                      className='form-control'
                      style={RedColor ? { borderColor: "red",backgroundColor:"pink" } : {}}

                      value={Interest}
                      id="Interest"
                      onKeyPress={(e) => {
                        // Allow only numeric input
                        const isNumeric = /^[0-9]*$/.test(e.key);
                        if (!isNumeric) {
                          e.preventDefault();
                        }
                      }}
                      placeholder='Interest*'
                      disabled={EditEneble}

                      onChange={(e) => { setInterest(e.target.value) }}
                      onKeyDown={(e) => handleKeyDown(e, input6Ref, input4Ref)}
                      ref={input5Ref}
                    // disabled={Disable} 
                    />
                  </div>
                  <div className="col-lg-4">
                    <input
                      type="text"
                      name="Year"
                      className='form-control'
                      id="Year"
                      onKeyPress={(e) => {
                        // Allow only numeric input
                        const isNumeric = /^[0-9]*$/.test(e.key);
                        if (!isNumeric) {
                          e.preventDefault();
                        }
                      }}
                      value={BookingPeriod}
                      placeholder='Period (in Year)*'
                      disabled={EditEneble}

                      onChange={(e) => { setPeriod(e.target.value) }}
                      onKeyDown={(e) => handleKeyDown(e, input7Ref, input5Ref)}
                      ref={input6Ref}
                    // disabled={Disable} 
                    />
                  </div>
                </div>

                <div className="row ">
                  <div className="col-lg-4">
                    <input
                      type={inputType}
                      placeholder="Booked On*"
                      onFocus={(event) => (event.target.type = 'date')}
                      name="booked-on-date"
                      className="form-control"
                      onBlur={(e) => handleBlur(e, BookedOn)}

                      // onChange={handleDateChange}
                      onChange={(e) => { setBookedOn(e.target.value) }}
                      id=""
                      onKeyDown={(e) => handleKeyDown2(e, input8Ref, input6Ref)}
                      ref={input7Ref}
                      value={BookedOn}
                      disabled={EditEneble}
                    // value={new Date()?'':BookedOn}
                    // disabled={Disable} 
                    />
                    
                  </div>


                  <div className="col-lg-4">
                  <input
      type={inputType}

      name="expired-on-date"
      className='form-control'
      id=""
      onBlur={(event) => handleBlur(event, ExpiryDate)}
      onFocus={(event) => (event.target.type = 'date')}
      // onFocus={handleFocus}
      onChange={(e) => { setExpiryDate(e.target.value) }}
      value={ExpiryDate}
      placeholder='Expiry Date*'
      disabled={EditEneble}

      onKeyDown={(e) => handleKeyDown2(e, input9Ref, input7Ref)}
      ref={input8Ref}
    />
                  </div>
                  <div className="col-lg-4">
                    <input
                      type="text"
                      name="Booked On/code"
                      onFocus={handleFocus}
                      onBlur={handleBlur}
                      className='form-control'
                      id="Booked On/code"
                      placeholder='Code'
                      disabled={EditEneble}
                      data-tip="hiii"

                      onKeyDown={(e) => handleKeyDown(e, input10Ref, input8Ref)}
                      ref={input9Ref}
                      value={Code}
                      onKeyPress={(e) => {
                        // Allow only numeric input
                        const isNumeric = /^[0-9]*$/.test(e.key);
                        if (!isNumeric) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => { setCode(e.target.value) }}
                    // disabled={Disable} 
                    />
                  </div>
                </div> <div className="row">
                  <div className="col-lg-8">
                    <textarea
                      name="Address"
                      className='form-control'
                      id="Address" cols="30" rows="3"
                      placeholder='Address*'
                      disabled={EditEneble}

                      value={Address}
                      onChange={(e) => { setAddress(e.target.value) }}
                      onKeyDown={(e) => handleKeyDown4(e, input11Ref, input9Ref)}
                      // disabled={Disable} 
                      ref={input10Ref}>


                    </textarea>
                  </div>
                  <div className="col-lg-4">
                    <Select

                      name="ReminderMethod"
                      className=' address-input'
                      id="ReminderMethod"
                      // isDisabled={Disable} 


                      placeholder='Remind Method'
                      isDisabled={EditEneble}

                      value={ReminderMethod}
                      onChange={(selectedOption) => setReminderMethod(selectedOption)}
                      onKeyDown={(e) => handleKeyDown2(e, input12Ref, input10Ref)}
                      ref={input11Ref}
                      options={OptionMethod}
                      // value={OptionMethod.find((option)=>option.value===ReminderMethod)}


                      styles={customStyles}


                    />
                    <input
                      type="text"
                      name=""
                      value={Reminder}
                      onChange={(e) => { setRemind(e.target.value) }}
                      className='form-control address-input mt-1'
                      id=""
                      placeholder='Remind Before In Days'
                      disabled={EditEneble}

                      onKeyPress={(e) => {
                        // Allow only numeric input
                        const isNumeric = /^[0-9]*$/.test(e.key);
                        if (!isNumeric) {
                          e.preventDefault();
                        }
                      }}
                      onKeyDown={(e) => handleKeyDown(e, input13Ref, input11Ref)}
                      ref={input12Ref}
                    // disabled={Disable} 

                    />
                  </div>
                </div>
              </div>
            </div>

          </div>


          <div className="row">
            <div className="container">
              {/* <div className="col-lg-12 card" style={{ background: 'linear-gradient(to right, #abdcff, #febad3)' }}> */}
              <div className="row">
                <div className="col-lg-10"></div>

                {/* </div> */}
              </div>
            </div>
          </div>



          <div className="row ">
            <div className="container-fluid tab">

              <div className="col-lg-12 card" style={{ background: "linear-gradient(to right, #f3dcfb, #679fe4)", height: "50vh" }}>
                <div className="container-fluid">
                  <div className="row">
                    {/* <b>Seva List</b><b>Total:{totalRate}</b> */}
                    <div className="col 8 d-flex justify-content-start"><b> Seva List</b></div>
                    <div className="col-4 d-flex justify-content-end"><b>Total:{totalRate} ₹</b></div>
                  </div></div>

                <div className="row">
                  <div className="col-lg-12 table-container" style={tableContainerStyle}>
                    <table className="table table-hover fixed-headers overflow-y: auto;">
                      <thead className="thead-dark">
                        <tr>
                          <th scope="col" className="th">#</th>
                          <th scope="col" className="th">Devotee name</th>
                          <th scope="col" className="th">Vazhipadu</th>
                          <th scope="col" className="th">Quantity</th>
                          <th scope="col" className="th">Rate</th>
                          <th scope="col" className="th">Edit</th>
                          <th scope="col" className="th">Delete</th>
                        </tr>
                      </thead>
                      <tbody style={{ height: '30vh' }}>
                        {sevaListArray.map((item, index) => {
                          // Find the corresponding item in sevaData.resultdata based on VazhipaduId
                          const vazhipaduItem = SevaData.resultdata.find(dataItem => dataItem.Id === item.VazhipaduId);

                          // Check if the corresponding item is found
                          const vazhipaduLabel = vazhipaduItem ? vazhipaduItem.VName : '';

                          return (
                            <tr key={index}>
                              <td className="index-column">{index + 1}</td>
                              <td className={item.CalendarType === 4 ? 'td2' : ''}>{item.PerformedFor}</td>
                              <td>{vazhipaduLabel}</td>
                              <td>{item.Quantity}</td>
                              <td>{item.Rate}</td>

                              <td>
                                <div className='btn2' style={{ color: "darkblue", display: 'flex', alignItems: 'center' }}>
                                  <MdOutlineEditNote className='customIcon' style={{ color: "green" }} />
                                  <span onClick={() => handleEditList(index)} style={{ marginLeft: '5px', cursor: 'pointer' }}>
                                    <h3>Edit</h3>
                                  </span>
                                </div>
                              </td>

                              <td>
                                <div className='btn2' style={{ color: "darkblue", display: 'flex', alignItems: 'center' }}>
                                  <RiDeleteBin6Line className='customIcon ' style={{ color: "#990000", height: "18px" }} />
                                  <span onClick={() => handelDelete(index)} style={{ marginLeft: '5px', cursor: 'pointer' }}>
                                    <h3>Delete</h3>
                                  </span>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>

                    </table>


                  </div>


                  <div className="container-fluid">
                    <div className="row">
                    <div className='col-lg-8 d-flex justify-content-lg-end justify-content-center mt-2 mt-lg-0' >
                      {/* <button type='button' className='btn' style={{ backgroundColor: "#001766", color: "white" }} ref={input63Ref} onClick={HandelAdd}>
    Add
  </button> */}
                      <button type='button' className='btn' disabled={!Disabe} style={{ backgroundColor: "#001766", color: "white" }} ref={input63Ref} onClick={HandelSave}>
                        Save
                      </button>
                    </div>
                    
                    <button
                  type='button'
                  className='btn '
                  style={{
                    backgroundColor: "#001766",
                    color: "white",
                    border: "2px solid #001766",
                    borderRadius: "5px",
                  }}
                
                >
                  Print
                </button>
                   
                    <button
                  type='button'
                  className='btn ml-2'
                  style={{ backgroundColor: "#001766", color: "white" }}
                  // ref={input63Ref}
                  onClick={HandelClear}
                >
                  Clear
                </button>
                   
                    <button
                  type='button'
                  className='btn ml-2'
                  onBlur={handleBlur}
                  style={{
                    backgroundColor: "#001766",
                    color: "white",
                    border: "2px solid #001766",
                    borderRadius: "5px",
                  }}
                  disabled={Disabe}
                  // ref={input63Ref}
                  onClick={HandeleEditUpdate}
                >
                  Update
                </button>
                   

                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* ---------------------------------second----------------------------------- */}

        <div className="col-lg-5 card second">

          <div className="row ">
            <div className="container-fluid pl-2">
              <div className="col-lg-12 card ml-2 " style={{ background: 'linear-gradient(to right, #de9dc6, #eed4d1)' }}>
                {/*  */}

                <b className='pb-2'>Devotee Details</b>
                <div className="row">
                  <div className="col-lg-4">
                    <input
                      type="text"
                      value={PerformedFor}

                      className='form-control'
                      id="Performed For"
                      onFocus={handleFocus}
                      onBlur={handleBlur}
                      placeholder='Performed for*'
                      name="tPerformed for"
                      onChange={(e) => {
                        setPerformedFor(e.target.value);
                        setAdd(true);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, input14Ref, input12Ref)}
                      ref={input13Ref}
                    />
                  </div>
                  <div className="col-lg-4">
                    <input
                      type="text"
                      value={Gothram}
                      className='form-control'
                      id="Gothram"
                      name="Gothram"
                      placeholder='Gothram'
                      onChange={(e) => {
                        setGothram(e.target.value);
                        setAdd(true);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, input15Ref, input13Ref)}
                      ref={input14Ref}
                    />
                  </div>
                  <div className="col-lg-4">
                    <Select type="text"
                      name="Star"
                      
                      id="Star3"
                      placeholder="Star"
                      value={Star}
                      onChange={(selectedOption) => setStar(selectedOption)}
                      onKeyDown={(e) => handleKeyDown2(e, input16Ref, input14Ref)}
                      ref={input15Ref}
                      options={OptionStar}
                      styles={customStyles}
                    />
                  </div>
                </div>
                <div className="row">


                  <div className="col-lg-8 ">
                    <Select
                      options={
                        SevaData?.resultdata && SevaData?.resultdata.length > 0
                          ? SevaData?.resultdata.map((item) => {
                            return {
                              value: item.Code,
                              label: item.VName,
                              Id: item.Id,
                              Rate: item.Rate
                            };
                          })
                          : []
                      }
                      name=""
                      className=''
                      id="" placeholder='Seva*'
                      onKeyDown={(e) => handleKeyDown2(e, input17Ref, input15Ref)}
                      ref={input16Ref}
                      value={VazhipaduId}
                      onChange={handlevazhipadu}
                      isSearchable={true}
                      styles={customStyles}
                    />
                  </div>
                  <div className="col-lg-4 ">
                    <input
                      type="text"
                      name="Quantity"
                      className='form-control'
                      id="Quantity"
                      value={Quantity}
                      placeholder='Quantity*'
                      onKeyPress={(e) => {
                        // Allow only numeric input
                        const isNumeric = /^[0-9]*$/.test(e.key);
                        if (!isNumeric) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        setQuantity(e.target.value);
                        setAdd(true);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, input19Ref, input16Ref)}
                      ref={input17Ref}
                    />
                  </div>


                </div>
                <div className="row">
                  <div className="col-lg-4 ">
                    <input

                      name="Rate"
                      className='form-control'
                      id="Rate"
                      value={Rate}
                      placeholder='Rate*'

                      onKeyPress={(e) => {
                        // Allow only numeric input
                        const isNumeric = /^[0-9]*$/.test(e.key);
                        if (!isNumeric) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        setRate(e.target.value);
                        setAdd(true);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, input19Ref, input17Ref)}
                      ref={input18Ref}
                    />
                  </div>
                  <div className="col-lg-4 ">
                    <input
                      type="text"
                      name="Importance"
                      className='form-control'
                      id="Importance"
                      value={Importance}
                      onChange={(e) => {
                        setImportance(e.target.value);

                      }}
                      placeholder='Importance Of The Day'
                      onKeyDown={(e) => handleKeyDown(e, input20Ref, input17Ref)}
                      ref={input19Ref}
                    />
                  </div>
                  <div className="col-lg-4 ">
                    <input
                      type="text"
                      name="remark"
                      className='form-control'
                      id="remark"
                      onChange={(e) => {
                        setRemark(e.target.value)

                      }}
                      value={Remarks}
                      placeholder='Remarks'
                      onKeyDown={(e) => handleKeyDown(e, input21Ref, input19Ref)}
                      ref={input20Ref}
                    />
                  </div>


                </div>
                <div className="row">
                  <div className="col-lg-10"></div>
                  <div className="col-lg-2 justify-content-end d-flex">
                    {/* <button onClick={HandelAdd} className='btn 'style={{backgroundColor:"#001766" , color:"white"}}  ref={input61Ref}>Add</button> */}

                  </div>

                </div>

              </div>

            </div>




          </div>




          <div className="container card " style={cardStyle}>
            <div className="row">
              <div className="col-lg justify-content-start d-flex mb-1">
                <b>Calendar Details</b>
              </div>

            </div>
            <div className="row ">
              <div className="col-lg-12">
                <Select

                  className=" mb-2"
                  value={Options.find((option) => option.value === CalendarType)}
                  // onChange={(selectedOption) => setCalenderType(selectedOption.value),setRatestae(false)}
                  onChange={(selectedOption) => { setCalenderType(selectedOption.value); setRatestae(false); }}

                  // onKeyDown={(e) => handleKeyDown2(e, input10Ref,input8Ref)}
                  ref={input21Ref}
                  onKeyDown={(e) => handlecalender(e, input25Ref, input35Ref, input43Ref, input20Ref)}
                  // onMenuClose={handleMenuClose}
                  options={Options}
                  styles={customStyles}

                />
              </div>
            </div>
            {/* -------------------------------------------------------Malayalam----------------------------------------------- */}



            {Malayalam ? (
              <div>
                <div className="row mb-4">
                  <div className="col-lg-12">
                    <Select
                      type="text"
                      name="mont"
                      className='month'
                      id="Month"
                      placeholder='Month*'
                      // value={MalayalamMonths.find((option)=>option.value === Month)}
                      value={Month}
                      onChange={(selectedOption) => setMonth(selectedOption)}
                      onKeyDown={(e) => handleKeyDown2(e, input26Ref, input21Ref)}
                      ref={input25Ref}
                      options={MalayalamMonths}
                      styles={customStyles}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-12 mb-2  ">
                    <Select

                      // type="text" 
                      name=""
                      // className='form-control' 
                      className='month'
                      id=""
                      placeholder='Day'
                      value={Day}
                      onChange={(selectedOption) => setDay(selectedOption)}
                      onKeyDown={(e) => handleKeyDown2(e, input27Ref, input25Ref)}
                      options={DaysOption}
                      ref={input26Ref}
                      styles={customStyles}
                      menuPlacement='top'

                    />
                  </div>

                </div>
                <div className="row">
                  <div className="col-lg-5 "></div>
                  <div className="col-lg-2 justify-content-centre d-flex or "><b>or</b></div>
                  <div className="col-lg-5"></div>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <Select

                      name=""
                      className=''
                      id=""
                      placeholder='Repeat'
                      // value={WeekIndex}
                      value={weekindex1}
                      onKeyDown={(e) => handleKeyDown2(e, input28Ref, input26Ref)}
                      // onChange={(selectedOption) => setWeekIndex(selectedOption)}
                      onChange={(selectedOption)=>setweekindex1(selectedOption)}
                      options={EveryDay1}
                      styles={customStyles}
                      menuPlacement="top"
                      ref={input27Ref} />

                  </div>
                  <div className="col-lg-6">
                    <Select

                      name=""
                      className=''
                      id=""
                      placeholder='Star'
                      onKeyDown={(e) => handleKeyDown2(e, input29Ref, input27Ref)}
                      value={PakshaOrStar}
                      onChange={(selectedOption) => setPaksha(selectedOption)}
                      ref={input28Ref}
                      options={OptionStar}
                      styles={customStyles}
                      menuPlacement='top'
                    />




                  </div>


                </div>
                <div className="row mt-1">
                  <div className="col-lg-12 mt-1">
                    <input
                      type="text"
                      name=""
                      value={Occurrence}
                      // value={Ocuurence1}
                      className='form-control'
                      id="Occurance"
                      onChange={(e) => {
                        setOccurance(e.target.value)
                        setAdd(true);
                      }}
                      // onChange={(e)=>{setOcuurence1(e.target.value)}}
                      placeholder='Occurrence'
                      onKeyPress={(e) => {
                        // Allow only numeric input
                        const isNumeric = /^[0-9]*$/.test(e.key);
                        if (!isNumeric) {
                          e.preventDefault();
                        }
                      }}

                      onKeyDown={(e) => handleKeyDown(e, input32Ref, input28Ref)}
                      ref={input29Ref}
                    />
                  </div>


                </div>
                <div className="row">
                  <div className="col-lg-5"></div>
                  <div className="col-lg-2 justify-content-centre d-flex or"><b>or</b></div>
                  <div className="col-lg-5"></div>
                </div>
                <div className="row ">

                </div>
                <div className="row mt-1">
                  <div className="col-lg-12 mb-2">
                    <Select
                      type="text"
                      name=""
                      className=''
                      id=""
                      placeholder='Repeat'
                      // value={WeekIndex}
                      value={weekindex2}
                      menuPlacement="top"
                      options={EveryDay2}
                      styles={customStyles}
                      // onChange={(selectedOption) => setWeekIndex(selectedOption)}
                      onChange={(selectedOption)=>setweekindex2(selectedOption)}
                      onKeyDown={(e) => handleKeyDown2(e, input30Ref, input29Ref)}

                      ref={input32Ref} />
                  </div>

                  <div className="col-lg-12">
                    <Select
                      type="text"
                      menuPlacement="top"

                      name=""
                      className=''
                      id=""

                      value={WeekDay}
                      onChange={(selectedOption) => setweek(selectedOption)}
                      placeholder='WeekDay'
                      options={optionWeek}
                      onKeyDown={(e) => handleKeyDown2(e, input60Ref, input32Ref)}
                      ref={input30Ref}
                      styles={customStyles}

                    />
                  </div>

                </div>
              </div>
            ) : English ? (
              <div>
                <div className="row mb-4">
                  <div className="col-lg-12">
                    <Select
                      type="text"
                      name="mont"
                      className='month'
                      id="Month"
                      placeholder='Month*'
                      onChange={(selectedOption) => setMonth(selectedOption)}
                      // value={EnglishMonths.find((option) => option.value === Month)}
                      value={Month}
                      onKeyDown={(e) => handleKeyDown2(e, input36Ref, input21Ref)}
                      ref={input35Ref}
                      options={EnglishMonths}
                      styles={customStyles}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12 mb-2">
                    <Select
                      // type="text" 
                      name="Day"
                      className=''
                      // value={DaysOption.find((option)=>option.value===Day)}
                      value={Day}
                      onChange={(selectedOption) => setDay(selectedOption)}
                      id="Day"
                      placeholder='Day'
                      onKeyDown={(e) => handleKeyDown2(e, input39Ref, input35Ref)}
                      ref={input36Ref}
                      styles={customStyles}
                      options={DaysOption}
                      menuPlacement='top'
                    />
                  </div>

                </div>
                <div className="row">
                  <div className="col-lg-5"></div>
                  <div className="col-lg-2 justify-content-centre d-flex or"><b>or</b></div>
                  <div className="col-lg-5"></div>
                </div>
                <div className="row">
                  <div className="col-lg-6 mt-1">
                    <Select
                      type="text"
                      name=""
                      className=''
                      id=""
                      placeholder='Repeat'
                      value={weekindex1}
                      onKeyDown={(e) => handleKeyDown2(e, input37Ref, input36Ref)}
                      onChange={(selectedOption) => setweekindex1(selectedOption)}
                      options={EveryDay}
                      styles={customStyles}
                      ref={input39Ref}
                    />
                  </div>
                  <div className="col-lg-6">
                    <Select
                      name=""
                      className=''
                      id=""
                      placeholder='Star'
                      onKeyDown={(e) => handleKeyDown2(e, input38Ref, input39Ref)}
                      value={PakshaOrStar}
                      onChange={(selectedOption) => setPaksha(selectedOption)}
                      ref={input37Ref}
                      options={OptionStar}
                      styles={customStyles}
                      menuPlacement='top'
                    />
                  </div>


                </div>
                <div className="row mt-1">
                  <div className="col-lg-12 mt-1">
                    <input
                      type="text"
                      name=""
                      value={Occurrence}
                      className='form-control'
                      id="Occurance"
                      onChange={(e) => {
                        setOccurance(e.target.value)
                        setAdd(true);
                      }}


                      placeholder='Occurrence'
                      onKeyPress={(e) => {
                        // Allow only numeric input
                        const isNumeric = /^[0-9]*$/.test(e.key);
                        if (!isNumeric) {
                          e.preventDefault();
                        }
                      }}
                      onKeyDown={(e) => handleKeyDown(e, input42Ref, input37Ref)}
                      ref={input38Ref}
                    />
                  </div>


                </div>
                <div className="row">
                  <div className="col-lg-5"></div>
                  <div className="col-lg-2 justify-content-centre d-flex or"><b>or</b></div>
                  <div className="col-lg-5"></div>
                </div>
                <div className="row">

                </div>
                <div className="row">
                  <div className="col-lg-12 mb-2">
                    <Select
                      type="text"
                      name=""
                      className=''
                      id=""
                      placeholder='Repeat'
                      menuPlacement='top'
                      value={weekindex2}
                      onChange={(selectedOption) => setweekindex2(selectedOption)}
                      options={EveryDay}
                      styles={customStyles}
                      onKeyDown={(e) => handleKeyDown2(e, input40Ref, input38Ref)}
                      ref={input42Ref} />
                  </div>

                  <div className="col-lg-12">
                    <Select
                      type="text"
                      name=""
                      // value={optionWeek.find((option) => option.value === WeekDay)}
                      value={WeekDay}
                      onChange={(selectedOption) => setweek(selectedOption)}
                      className=''
                      id=""
                      placeholder='WeekDay'
                      menuPlacement="top"
                      onKeyDown={(e) => handleKeyDown2(e, input60Ref, input42Ref)}
                      ref={input40Ref}
                      options={optionWeek}
                      styles={customStyles}
                    />
                  </div>

                </div>
              </div>
            ) : Sanskrit ? (<div>
              <div className="row mb-4">
                <div className="col-lg-12">
                  <Select
                    type="text"
                    name="mont"
                    className='month'
                    // value={SanskritMonths.find((option) => option.value === Month)}
                    value={Month}
                    id="Month"
                    placeholder='Month*'
                    onChange={(selectedOption) => setMonth(selectedOption)}
                    onKeyDown={(e) => handleKeyDown2(e, input44Ref, input21Ref)}
                    options={SanskritMonths}
                    ref={input43Ref}
                    styles={customStyles}
                  />
                </div>
              </div>
              <div className="row">

                <div className="col-lg-12">
                  <Select

                    name=""
                    className=''
                    id=""
                    value={PakshaOrStar1}
             
                    placeholder='Paksha Or Star'
                    onKeyDown={(e) => handleKeyDown2(e, input45Ref, input43Ref)}
                    onChange={(selectedOption) => setPaksha1(selectedOption)}
                    ref={input44Ref}
                    options={OptionPaksha}
                    styles={customStyles}
                    menuPlacement='top'
                  />
                </div>

              </div>
              <div className="row mt-2">
                <div className="col-lg-6">
                  <Select
                    type="text"
                    name="Day"
                    className=''
                    id="Day"
                    placeholder='Day'
                    value={Day}
                    onChange={(selectedOption) => setDay(selectedOption)}
                    onKeyDown={(e) => handleKeyDown2(e, input46Ref, input44Ref)}
                    styles={customStyles}
                    options={DaysOption}
                    menuPlacement='top'
                    ref={input45Ref} />
                </div>
                <div className="col-lg-6">
                  <input
                    type="text"
                    name=""
                    className='form-control'
                    // onChange={(e)=>{setOccurance(e.target.value)}}
                    id="Occurance"
                    placeholder='Occurrence'
                    onKeyPress={(e) => {
                      // Allow only numeric input
                      const isNumeric = /^[0-9]*$/.test(e.key);
                      if (!isNumeric) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      setOccurance1(e.target.value)
                      setAdd(true);
                    }}
                    onKeyDown={(e) => handleKeyDown2(e, input47Ref, input45Ref)}
                    ref={input46Ref}
                    value={Occurrence1}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-5"></div>
                <div className="col-lg-2 justify-content-center d-flex or2"><b>or</b></div>
                <div className="col-lg-5"></div>
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <Select
                    type="text"
                    name=""
                    className=''
                    id=""
                    value={PakshaOrStar2}
                    onChange={(selectedOption) => setPaksha2(selectedOption)}
                    placeholder='Star'
                    onKeyDown={(e) => handleKeyDown2(e, input48Ref, input46Ref)}
                    // onChange={(selectedOption) => setStar(selectedOption.value)}
                    ref={input47Ref}
                    options={OptionStar}
                    styles={customStyles}
                    menuPlacement='top'
                  />
                </div>
                <div className="col-lg-6">
                  <input
                    type="text"
                    name=""
                    className='form-control'
                    id="Occurance"
                    value={Occurrence2}
                    placeholder='Occurrence'
                    onChange={(e) => {
                      setOccurance2(e.target.value)
                      setAdd(true);
                    }}
                    onKeyPress={(e) => {
                      // Allow only numeric input
                      const isNumeric = /^[0-9]*$/.test(e.key);
                      if (!isNumeric) {
                        e.preventDefault();
                      }
                    }}
                    onKeyDown={(e) => handleKeyDown2(e, input50Ref, input47Ref)}
                    ref={input48Ref} />


                </div>

              </div>
              <div className="row">
                <div className="col-lg-5"></div>
                <div className="col-lg-2 justify-content-center d-flex or2"><b>or</b></div>
                <div className="col-lg-5"></div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <Select
                    type="text"
                    name=""
                    className=''
                    id=""
                    // onChange={(e)=>{setWeekIndex(e.target.value)}}
                    value={weekindex2}
                    placeholder='Repeat'
                    menuPlacement="top"
                    // value={Repeat} 
                    onChange={(selectedOption) => setweekindex2(selectedOption)}
                    options={EveryDay}
                    onKeyDown={(e) => handleKeyDown2(e, input49Ref, input48Ref)}
                    ref={input50Ref}
                    styles={customStyles}
                  />
                </div>
                <div className="col-lg-6">
                  <Select
                    type="text"
                    name=""
                    className=''
                    id=""
                    placeholder='Week'
                    menuPlacement="top"
                    options={optionWeek}
                    value={WeekDay}
                    onChange={(selectedOption) => setweek(selectedOption)}

                    styles={customStyles}
                    onKeyDown={(e) => handleKeyDown2(e, input60Ref, input50Ref)}
                    ref={input49Ref} />
                </div>

              </div>
            </div>) : ""}

          </div>



          <div className="container card" style={{ background: Green ? "#5EBE76" : 'linear-gradient(to right, #cc9a99, #ad9fff)' }}>    {/* */}
            <div className="row mt-1">
              <div className="col-lg-4 justify-content-start">
                
                <Select
  options={
    mode && mode.length > 0
      ? mode.map((item) => ({
          value: item.BMode,
          label: item.BName,
        }))
      : []
  }
  className='mb-2'
  menuPlacement="top"
  value={PaymentMethod}
  onChange={Handelmode}
  onKeyDown={(e) => handleKeyDown2(e, input63Ref, input21Ref)}
  tabIndex="1"
  ref={input60Ref}
  placeholder="cash"
  styles={customStyles}
/>

              </div>
              <div className="col-lg-2"></div>

              <div className="col-lg-6 d-flex justify-content-lg-end justify-content-center mt-2 mt-lg-0">
                {/* Update Button */}
                {/* <button
                  type='button'
                  className='btn'
                  style={{
                    backgroundColor: "#001766",
                    color: "white",
                    border: "2px solid #001766",
                    borderRadius: "5px",
                  }}
                  disabled={Disabe}
                  // ref={input63Ref}
                  onClick={HandeleEditUpdate}
                >
                  Update
                </button> */}

                {/* Clear Button */}
                {/* <button
                  type='button'
                  className='btn ml-2'
                  style={{ backgroundColor: "#001766", color: "white" }}
                  // ref={input63Ref}
                  onClick={HandelClear}
                >
                  Clear
                </button> */}

                {/* Add Button */}
                <button
                  type='button'
                  className='btn ml-2'
                  style={{ backgroundColor: "#001766", color: "white" }}
                  ref={input63Ref}

                  onClick={HandelAdd}
                >
                  Add
                </button>
                {/* <button
                  type='button'
                  className='btn ml-2'
                  style={{
                    backgroundColor: "#001766",
                    color: "white",
                    border: "2px solid #001766",
                    borderRadius: "5px",
                  }}
                
                >
                  print
                </button> */}
              </div>
            </div>

          </div>
          {isPopupOpen && (
            <Modal
              show={isPopupOpen}
              onHide={handleClosePopup}
              className=" align-items-center "
              style={{
                perspective: "1000px",
                transformStyle: "preserve-3d",
                transform: 'translateZ(0)',
              }}
            >
              <Modal.Header style={{ background: '#001766', color: 'white' }}>
                <Modal.Title>
                  <b>Search By Number</b>
                </Modal.Title>
                <Button
                  variant="secondary"
                  onClick={handleClosePopup}
                  style={{ color: 'white', border: 'none', backgroundColor: 'transparent', fontSize: '2em' }}
                >
                  &#215; {/* Unicode character for "times" symbol */}
                </Button>
              </Modal.Header>
              <Modal.Body style={{ background: 'white' }}>
                <Form.Control
                  type="text"
                  placeholder="Enter Devotee Number"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
              </Modal.Body>
              <Modal.Footer style={{ background: 'white' }}>
                <Button variant="primary" onClick={handlePopupSubmit}>
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>



          )}
          {ShowModal2&&(
               <Modal show={ShowModal2} onHide={handleModalClose}>
        <Modal.Header style={{ background: '#001766', color: 'white' }}>
          <Modal.Title>Logout Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to logout?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleLogoutConfirmed}>
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
   ) }

          {Loader ? (
            <div className="loader-container">
              <div className="loader"></div>
            </div>
          ) : (
            null
          )}

{DeleteModal && (
        <Modal show={DeleteModal} onHide={() => setDeleteModal(false)}>
          <Modal.Header>
            <Modal.Title>Delete Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this item?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setDeleteModal(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={confirmDelete}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      )}
        </div>

      </div>

    </div>
  )
}

export default Endownment2